import React from 'react';
import Icon from '../../../components/AppIcon';
import { useTheme } from '../../../contexts/ThemeContext';

const LocationStats = ({ locations }) => {
  const { isDarkMode } = useTheme();
  const openLocations = locations?.filter(loc => loc?.status === 'Open')?.length;
  const totalServices = [...new Set(locations.flatMap(loc => loc.services))]?.length;
  const averageDistance = locations?.reduce((sum, loc) => sum + parseFloat(loc?.distance), 0) / locations?.length;
  const featuredCount = locations?.filter(loc => loc?.featured)?.length;

  const stats = [
    {
      icon: 'MapPin',
      label: 'Total Locations',
      value: locations?.length,
      color: 'text-white',
      bgColor: 'bg-gradient-to-br from-blue-500 to-blue-600',
      cardBg: isDarkMode ? 'bg-gradient-to-br from-blue-900/30 to-blue-800/30' : 'bg-gradient-to-br from-blue-50 to-blue-100',
      borderColor: isDarkMode ? 'border-blue-600/50' : 'border-blue-200'
    },
    {
      icon: 'Clock',
      label: 'Open Now',
      value: openLocations,
      color: 'text-white',
      bgColor: 'bg-gradient-to-br from-green-500 to-green-600',
      cardBg: isDarkMode ? 'bg-gradient-to-br from-green-900/30 to-green-800/30' : 'bg-gradient-to-br from-green-50 to-green-100',
      borderColor: isDarkMode ? 'border-green-600/50' : 'border-green-200'
    },
    {
      icon: 'Package',
      label: 'Services Available',
      value: totalServices,
      color: 'text-white',
      bgColor: 'bg-gradient-to-br from-purple-500 to-purple-600',
      cardBg: isDarkMode ? 'bg-gradient-to-br from-purple-900/30 to-purple-800/30' : 'bg-gradient-to-br from-purple-50 to-purple-100',
      borderColor: isDarkMode ? 'border-purple-600/50' : 'border-purple-200'
    },
    // {
    //   icon: 'Star',
    //   label: 'Featured Points',
    //   value: featuredCount,
    //   color: 'text-white',
    //   bgColor: 'bg-gradient-to-br from-orange-500 to-orange-600',
    //   cardBg: isDarkMode ? 'bg-gradient-to-br from-orange-900/30 to-orange-800/30' : 'bg-gradient-to-br from-orange-50 to-orange-100',
    //   borderColor: isDarkMode ? 'border-orange-600/50' : 'border-orange-200'
    // }
  ];

  return (
    <div className="grid grid-cols-2 lg:grid-cols-3 gap-3 mb-6">
      {stats?.map((stat, index) => (
        <div
          key={index}
          className={`${stat?.cardBg} rounded-xl p-4 shadow-elevation-1 hover:shadow-elevation-2 transition-all duration-300 border ${stat?.borderColor}`}
        >
          <div className="flex items-center justify-between mb-2">
            <div className={`w-10 h-10 rounded-2xl ${stat?.bgColor} flex items-center justify-center`}>
              <Icon name={stat?.icon} size={20} className={stat?.color} />
            </div>
            <div className="text-right">
              <div className={`text-2xl font-bold ${isDarkMode ? 'text-white' : 'text-foreground'}`}>
                {stat?.value}
              </div>
            </div>
          </div>
          <p className={`text-sm font-medium ${isDarkMode ? 'text-slate-300' : 'text-muted-foreground'}`}>
            {stat?.label}
          </p>
        </div>
      ))}
    </div>
  );
};

export default LocationStats;